//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';

export default {
  components: {},
  name: 'functionList',
  props: ['listBox','isMine','isShop'],
  data() {
    return {
      timeOutEvent: 0,
      isclick: false
    };
  },
  methods: {
    ...mapActions([]),
    showDeleteButton(e) {
      let that = this;
      if(that.isShop) { //只有在商店页面才会执行
        e.preventDefault(); 
        e.stopPropagation();
        if(document.querySelectorAll('.list-iconbox')[0].classList.contains('active')){
          var iconboxes = document.querySelectorAll('.list-iconbox');
          iconboxes.forEach(e => {
            e.classList.remove('active');
          })
          that.isclick = true
        }else{
          that.timeOutEvent = setTimeout(function(){
            var iconboxes = document.querySelectorAll('.list-iconbox');
            iconboxes.forEach(e => {
              e.classList.add('active');
            })
          },500)
        }
      }
    },
    cancelShow(index,url) {
      if(this.isShop) { //只有在商店页面才会执行
        clearTimeout(this.timeOutEvent);
        if(this.isclick) {
          console.log(index); //选中目标在数组中的index
          console.log(this.listBox[index]); //选中目标的对象内容
        }else if(!document.querySelectorAll('.list-iconbox')[0].classList.contains('active')){
          window.location.href = url; //不长按触发跳转页面
        }
      }
      this.isclick = false;
    }
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
